import axios from "../axiosInstance";

class StatusContractSignatureService {
  async getStatusContractSignatureList() {
    return await axios.get("statuscontractsignature");
  }
}

export default new StatusContractSignatureService();
